import { errStandard } from './err-features/err-standard';
import { reqStandard } from './req-features/req-standard';
import { resStandard } from './res-features/res-standard';
export const standard = () => [reqStandard(), resStandard(), errStandard()];
